module.exports = __webpack_public_path__ + "static/media/Icon__B.4d264c08.png";